$(function () {
    'use strict';

    function Register($scope) {

        let _this = this;

        let $form;
        let $buttonSubmit;

        /**
        * Initialize
        */
        let init = function () {

            $form = $scope.find('[data-id=form]');
            $buttonSubmit = $scope.find('[data-id=buttonSubmit]');

            initObservers();
        };

        /**
        * Initialize the observers
        */
        let initObservers = function () {
            $form.on('submit', formSubmitHandler);
        };

        let formSubmitHandler = function(e) {
            $buttonSubmit.prop('disabled', true);
            $buttonSubmit.addClass('loading');
        }

        init();

        return _this;
    }

    return new Register($('[data-id=register]'));
});
